<template>
  <div class="leaderboard-number-of-players">
    <!-- number of teams -->
    <div
      v-if="isShowingTeamList"
      class="ml-2 count-player"
    >
      <span v-if="rankingListCount == 1">
        1 {{ $t('team') }}
      </span>
      <span v-if="rankingListCount != 1">
        {{ displayedNumberOfPlayers }} {{ $t('teams') }}
      </span>
    </div>
    <!-- number of participants -->
    <div
      v-else
      class="count-player"
    >
      <span v-if="rankingListCount == 1">
        {{ $t('player', { msg: 1 }) }}
      </span>
      <span v-else>
        {{ $t('players', { msg: displayedNumberOfPlayers }) }}
      </span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    displayedNumberOfPlayers: {
      type: [String, Number],
      default: null,
    },
    rankingListCount: {
      type: Number,
      default: null,
    },
    isShowingTeamList: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">

.leaderboard-number-of-players {
  color: #ccc;
  .count-player {
    text-align: center;
  }
  margin-bottom: 1.5rem;
  .light & {
    @apply text-base-80;
  }
}
</style>
